import React from 'react';

export const InterviewDetailsTabContent = () => <div>Interview Details Tab Content</div>;
